/**
 * Desafío TOTP -- el usuario ya está enrolado, solo prueba el código del
 * momento. Llega aquí via RequireSession -> guards.tsx, que redirige
 * cuando `mfa === 'needs_challenge'`.
 */
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { mfaChallenge } from '../lib/backend';
import { Wordmark } from '../components/Logo';

export function MfaChallenge() {
  const { pendingMfaToken, completeMfa } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!pendingMfaToken) {
    return (
      <div className="authwrap">
        <div className="authcard">
          <p className="muted">Su sesión de verificación expiró. Vuelva a iniciar sesión.</p>
          <button className="btn btn--primary" style={{ marginTop: 12 }} onClick={() => nav('/login', { replace: true })}>
            Volver al inicio de sesión
          </button>
        </div>
      </div>
    );
  }

  async function verify() {
    if (!pendingMfaToken) return;
    setBusy(true);
    setError(null);
    try {
      const token = await mfaChallenge(pendingMfaToken, code.trim());
      await completeMfa(token);
      const from = (loc.state as { from?: string } | null)?.from ?? '/';
      nav(from, { replace: true });
    } catch {
      setError('Código incorrecto. Intente de nuevo.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="authwrap">
      <form
        className="authcard"
        style={{ maxWidth: 380 }}
        onSubmit={(e) => {
          e.preventDefault();
          void verify();
        }}
      >
        <div className="authbrand">
          <Wordmark size={38} />
        </div>
        <h2 style={{ fontSize: 19, marginBottom: 4 }}>Verificación en dos pasos</h2>
        <p className="muted" style={{ fontSize: 13, marginTop: 0, marginBottom: 18 }}>
          Ingrese el código de 6 dígitos de su aplicación de autenticación.
        </p>

        <div className="field">
          <label htmlFor="mfa-code">Código</label>
          <input
            id="mfa-code"
            inputMode="numeric"
            autoComplete="one-time-code"
            autoFocus
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            style={{ fontSize: 18, letterSpacing: 4, textAlign: 'center' }}
          />
          {error && <div className="errmsg">{error}</div>}
        </div>

        <button className="btn btn--primary" style={{ width: '100%', justifyContent: 'center' }} disabled={busy || code.length !== 6}>
          {busy ? 'Verificando…' : 'Verificar'}
        </button>
      </form>
    </div>
  );
}
